export const CMS_CONTENT_TYPE_CAMPAIGN = 'campaignBanner';
